import React from 'react';
import PropTypes from 'prop-types';
import TaskModule from 'modules/task';
import { Components, Utils, translate } from 'versafleet-core';
import { connect } from 'react-redux';
import ReduxActions from 'reduxActions';
import addOnsSettings from 'modules/addOns/addOnsConstants';
import JobHelper from 'utils/jobHelper';
import withRouterHooks from 'utils/routerHelper';

class TaskDetailEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: structuredClone({ ...this._getDefaultForm(), ...props.form }),
      error: {},
      showCloseModal: false,
    };
    this.onFormChange = this._onFormChange.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.dispatch(ReduxActions.customFieldGroup.fetchOptionCustomFieldGroupList());
    this.props.dispatch(ReduxActions.constant.fetchList());
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.customFieldGroups !== this.props.customFieldGroups
      && !Utils.Helper.isNullOrUndefined(nextProps.account.addons_setting)
      && nextProps.account.addons_setting.custom_field) {
      const customFieldGroupId = this.state.form.custom_field_group_id;

      this._onFormChange('custom_fields_attributes',
        this._getCustomFieldsDefaultForm(
          nextProps.form.custom_fields_attributes,
          nextProps.customFieldGroups[customFieldGroupId],
        ));
    }
  }

  _getDefaultForm() {
    let form = {
      address_attributes: {
        name: null,
        line_1: null,
        country: null,
        zip: null,
        contact_person: null,
        contact_number: null,
        email: null,
      },
      time_type: this.props.time.time_type,
      time_from: this.props.time.time_from,
      time_to: this.props.time.time_to,
      time_window_id: this.props.time.time_window_id,
      epod_attachments_attributes: [],
    };

    if (this.props.account.addons_setting.custom_field === addOnsSettings.subscribed) {
      form = {
        ...form,
        custom_field_group_id: null, // for validation
        custom_fields_attributes:
          this._getCustomFieldsDefaultForm(
            this.props.form.custom_fields_attributes,
            this.props.customFieldGroups[this.props.form.custom_field_group_id],
          ),
      };
    }

    return form;
  }

  _getCustomFieldsDefaultForm = (customFields, customFieldGroup) => {
    if (Utils.Helper.isNullOrUndefined(customFieldGroup)) {
      return [];
    }

    return customFieldGroup.custom_field_descriptions.map((item) => {
      const customField = Utils.Helper.isNullOrUndefined(customFields) ? {}
        : customFields.find((field) => {
          const id = Utils.Helper.isNullOrUndefined(field.custom_field_description)
            ? field.custom_field_description_id : field.custom_field_description.id;

          return id === item.id;
        });
      const value = (customField || {}).value;
      const subvalue = (customField || {}).subvalue;
      return {
        custom_field_description_id: item.id,
        value,
        subvalue,
        id: (customField || {}).id,
      };
    });
  }

  _onFormChange(fieldName, value, index, isDelete) {
    if (fieldName === 'custom_field_group_id') {
      this.setState(prevState => ({
        form: Utils.Helper.setFilter(prevState.form, null, {
          custom_field_group_id: value,
          custom_fields_attributes: [],
        }),
      }));

      if (!Utils.Helper.isNullOrUndefined(value)) {
        this.props.dispatch(ReduxActions.customFieldGroup.fetch(value));
      }
    } else if (fieldName === 'billing_account_id') {
      if (value && value !== '') {
        this.props.dispatch(ReduxActions.billingAccount.fetch(value));
      }
      this.setState(prevState => ({
        form: {
          ...prevState.form,
          billing_account_id: value,
        },
      }));
    } else {
      this.setState(prevState => ({
        form: Utils.Helper.setFilter(prevState.form, fieldName, value, index, isDelete),
      }));
    }
  }

  _renderButton() {
    const { form } = this.state;
    if (
      Utils.Helper.isNonEmptyString(form.address_attributes.country)
        && Utils.Helper.isNonEmptyString(form.address_attributes.line_1)
        && Utils.Helper.isNonEmptyString(form.time_from)
    ) {
      return (
        <Components.Form.MobileMainButton
          iconClassNam="versa-completed"
          id="vf-mobile-job__new-form__task-form__save-button"
          onClick={() => {
            Utils.FullScreenLoading.FullScreenLoadingManager.open(
              this.props.strings.Job.form.task.validating,
            );
            this.props.dispatch(ReduxActions.task.validate(this.state.form))
              .then(() => {
                if (this.props.index === null) {
                  // Its a new task
                  this.props.onFormChange('tasks_attributes', this.state.form);
                  this.props.setPage(JobHelper.PageConstants.JOB_DETAIL_EDIT);
                } else {
                  // Edit an existing task
                  this.props.onFormChange('tasks_attributes', this.state.form, this.props.index);
                  this.props.setPage(JobHelper.PageConstants.JOB_DETAIL_EDIT);
                }
              })
              .catch((error) => {
                this.setState({ error });
              })
              .then(() => {
                Utils.FullScreenLoading.FullScreenLoadingManager.close();
              });
          }}
        >
          {this.props.strings.Task.form.buttons.save}
        </Components.Form.MobileMainButton>
      );
    }

    return false;
  }

  render() {
    return (
      <Components.Form.MobileCoreLayout
        footer={this._renderButton()}
        header={(
          <Components.Mobile.NavigationBar
            leftButton={Components.Mobile.NavigationBar.buttonConst.CLOSE}
            onLeftButtonClick={() => {
              if (this.props.isChanged) {
                this.setState({ showCloseModal: true });
              } else {
                this.props.navigate('/jobs');
              }
            }}
            title={(
              <Components.Form.MobileTitle>
                <Components.Form.MobileTitle.Item key="title-job-type-info">
                  {this.props.form.job_type === 'pickup'
                    ? this.props.strings.Job.form.menu.jobDeliveryInfo
                    : this.props.strings.Job.form.menu.jobPickupInfo}
                </Components.Form.MobileTitle.Item>
                <Components.Form.MobileTitle.Item isHighlighted key="title-task-type-info">
                  {this.props.form.job_type === 'pickup'
                    ? this.props.strings.Job.form.menu.pickupTaskInfo
                    : this.props.strings.Job.form.menu.deliveryTaskInfo}
                </Components.Form.MobileTitle.Item>
              </Components.Form.MobileTitle>
            )}
          />
        )}
      >
        <TaskModule.Edit
          constant={this.props.constant}
          customFieldGroups={this.props.customFieldGroups}
          customer={this.props.customer}
          data={this.props.form}
          error={this.state.error}
          form={this.state.form}
          id="vf-mobile-job__new-form__task-form"
          isNewTask
          onFormChange={this.onFormChange}
          optionAddresses={this.props.optionAddresses}
          optionCustomFieldGroups={this.props.optionCustomFieldGroups}
        />
        <Components.Form.CloseConfirmationDialog
          leftButtonOnClick={() => this.props.navigate('/jobs')}
          rightButtonOnClick={() => this.setState({ showCloseModal: false })}
          visible={this.state.showCloseModal}
        />
      </Components.Form.MobileCoreLayout>
    );
  }
}

TaskDetailEdit.propTypes = {
  account: PropTypes.shape({
    addons_setting: PropTypes.shape({
      custom_field: PropTypes.number,
    }),
  }).isRequired,
  constant: PropTypes.shape({
    jobs: PropTypes.shape(),
  }).isRequired,
  customFieldGroups: PropTypes.shape({}),
  customer: PropTypes.shape({
    billing_accounts: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  form: PropTypes.shape({
    job_type: PropTypes.oneOf(['delivery', 'pickup', 'p2p']),
    custom_fields_attributes: PropTypes.arrayOf(PropTypes.shape()),
    custom_field_group_id: PropTypes.number,
  }).isRequired,
  index: PropTypes.number,
  isChanged: PropTypes.bool,
  navigate: PropTypes.func.isRequired,
  onFormChange: PropTypes.func.isRequired,
  optionAddresses: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    text: PropTypes.string,
  })),
  optionCustomFieldGroups: PropTypes.arrayOf(PropTypes.shape({})),
  setPage: PropTypes.func.isRequired,
  strings: PropTypes.shape({
    Job: PropTypes.shape({
      form: PropTypes.shape({
        menu: PropTypes.shape({
          jobDeliveryInfo: PropTypes.string,
          jobPickupInfo: PropTypes.string,
          pickupTaskInfo: PropTypes.string,
          deliveryTaskInfo: PropTypes.string,
        }),
        task: PropTypes.shape({
          validating: PropTypes.string,
        }),
      }),
    }),
    Task: PropTypes.shape({
      form: PropTypes.shape({
        buttons: PropTypes.shape({
          save: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
  time: PropTypes.shape({
    time_from: PropTypes.string,
    time_to: PropTypes.string,
    time_type: PropTypes.string,
    time_window_id: PropTypes.number,
  }).isRequired,
};

TaskDetailEdit.defaultProps = {
  customFieldGroups: {},
  index: null,
  isChanged: false,
  optionAddresses: [],
  optionCustomFieldGroups: [],
};

const mapStateToProps = (state) => {
  const {
    account, customFieldGroup, profile, constant,
  } = state;

  return {
    account: account.account,
    constant: constant.constant,
    customer: profile.profile,
    customFieldGroups: customFieldGroup.customFieldGroups,
    optionCustomFieldGroups: customFieldGroup.optionCustomFieldGroups,
  };
};

export default withRouterHooks(connect(mapStateToProps)(translate('')(TaskDetailEdit)));
